import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useNavigate } from "react-router-dom"
import ProfileMenu from "components/CommonForBoth/TopbarDropdown/ProfileMenu"
import "./nominee-form.scss"
import InfoPopup from "components/InfoPopup"
import { useFormik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import ImageCropModal from "components/ImageCropModal"
import { addAwardShortlistedDetails } from "../../../redux/actions/awards"
import { toast } from "react-toastify"
import { ADD_AWARD_SHORTLISTED_DETAILS_RESET } from "../../../redux/types/awards"
import portraitImage from "../../../assets/images/portrait-img.png"
import PageLoader from "components/Common/PageLoader"

const NomineeAwardFormTwo = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [previewOpen, setPreviewOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)

  const [profileFile, setProfileFile] = useState(null)

  const [error, setError] = useState(null)

  const awards = useSelector(state => state.auth.awards)
  const addAwardShortlistedDetailsScreen = useSelector(
    state => state.screens.awards.addAwardShortlistedDetails
  )

  useEffect(() => {
    if(!awards || awards.length === 0) {
      navigate("/awards-2025", {replace: true})
    }
  }, [awards])
  

  useEffect(() => {
    if (profileFile) {
      console.log("profileFile..", profileFile)
      setIsOpen(true)
    }
  }, [profileFile])

  useEffect(() => {
    if (addAwardShortlistedDetailsScreen.success) {
      toast.success(addAwardShortlistedDetailsScreen.message)
      dispatch({ type: ADD_AWARD_SHORTLISTED_DETAILS_RESET })
      navigate("/awards-billing-details", {})
    }
    if (addAwardShortlistedDetailsScreen.error) {
      toast.error(addAwardShortlistedDetailsScreen.error)
      dispatch({ type: ADD_AWARD_SHORTLISTED_DETAILS_RESET })
    }
  }, [addAwardShortlistedDetailsScreen])

  const togglePreview = () => setPreviewOpen(!previewOpen)

  const openPreview = () => {
    setPreviewOpen(true)
  }
  function onSelectFile(event) {
    console.log("files", event.target.files)

    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = e => {
        setProfileFile(e.target.result)
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  function saveImage(blob, blobUrl) {
    console.log("blob..", blob)
    const file = new File([blob], "my_profile_pic.jpg", {
      type: blob.type,
      lastModified: Date.now(),
    })
    setPreviewFile({
      name: file.name,
      type: "image/jpeg",
      file: file,
      url: blobUrl,
    })
  }

  function onSubmit() {
    if (!profileFile) {
      setError("Image is Required")
      return
    }
    // Proceed with form submission when profileFile is available
    console.log("Submitting form with profile:", profileFile)

    const formData = new FormData()
    formData.append("award_user_photo", previewFile.file)
    formData.append(
      "enc_award_nomination_id",
      awards[0].enc_award_nomination_id
    )
    dispatch(addAwardShortlistedDetails(formData))
  }

  document.title = "Nominee Awards Form | PULA"

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer pt-4">
          <div className="mb-4"></div>
          <div className="nomineeform-wrapper">
            <Row className="justify-content-center">
              <Col xs={12} sm={11} md={11}>
                <Card className="nominee-form-card">
                  <CardBody className="nominee-form-card-body p-0">
                    <div className="form-section">
                      <div className="descr-nominee">
                        <div className="text-center mb-3 mt-3">
                          <h1 className="title mb-2 h2">
                            Nomination Awards Form
                          </h1>
                        </div>
                        <p>{`Dear ${
                          awards && awards.length > 0 ? awards[0].full_name : ""
                        },`}</p>
                        <p className="mb-0">
                          Contagratulations 🎉 you have been selected. Please
                          upload the following documents to proceed further.
                        </p>
                        <div className="pt-4">
                          <div className="row">
                            <div className="col-12 col-md-8 mb-4">
                              <h2 className="font-size-18 mb-3">
                                Please read the instructions carefully before
                                you upload your documents
                              </h2>
                              <ul className="mb-0 ps-3">
                                <li className="mb-3">
                                  Your Passport size photo
                                </li>
                                <li className="mb-3">
                                  You should be alone in the photo
                                </li>
                                <li className="mb-3">
                                  Image should be clear and well-lit (no blur or
                                  shadows)
                                </li>
                                <li className="mb-3">
                                  Background should be plain and not cluttered
                                </li>
                                <li className="mb-3">
                                  Face should be clearly visible and centered
                                </li>
                                <li className="mb-3">
                                  No sunglasses or hats that obscure the face
                                </li>
                                <li className="mb-3">
                                  Ensure good lighting without harsh shadows
                                </li>
                              </ul>
                            </div>
                            <div className="col-12 col-md-4 mb-4 d-flex align-items-center justify-content-center">
                              <img
                                src={portraitImage}
                                alt="Portrait"
                                style={{
                                  maxWidth: "60%",
                                  height: "auto",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <h2 className="nom-title">Upload Image</h2>
                      <div className="mb-4">
                        {previewFile ? (
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 rounded-3 border">
                            <div className="d-flex align-items-center gap-3">
                              <span
                                className="rounded-circle d-inline-flex align-items-center justify-content-center"
                                style={{
                                  width: 32,
                                  height: 32,
                                  background: "#e7f6ef",
                                }}
                              >
                                <i className="mdi mdi-check text-success" />
                              </span>
                              <div>
                                <h3 className="mb-0">{previewFile.name}</h3>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-3 text-primary">
                              <button
                                type="button"
                                className="btn btn-link text-decoration-none p-0"
                                onClick={() => openPreview()}
                              >
                                View
                              </button>
                              <button
                                type="button"
                                className="btn btn-link text-danger text-decoration-none p-0"
                                onClick={() => {
                                  setPreviewFile(null)
                                  setProfileFile(null)
                                }}
                              >
                                <i className="mdi mdi-trash-can-outline fs-5" />
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div
                              className="rounded-3 text-center py-5 px-3"
                              style={{
                                border: "2px dashed #d6d6d6",
                                background: "#fcfcfc",
                                color: "#a5a5a5",
                              }}
                              onClick={() =>
                                document.getElementById("profilePic").click()
                              }
                            >
                              <i className="mdi mdi-cloud-upload-outline display-6 d-block mb-2" />
                              <p className="mb-0 fw-medium">
                                Click here to upload the file
                              </p>
                              <input
                                type="file"
                                className="hidden"
                                onChange={e => onSelectFile(e, "profilePic")}
                                id="profilePic"
                              />
                            </div>
                            {error && (
                              <div className="text-danger small mt-1">
                                {error}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      <div className="d-flex justify-content-center">
                        <button
                          onClick={onSubmit}
                          className="primary-button"
                          type="button"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ImageCropModal
          isOpen={isOpen}
          imgSrc={profileFile}
          saveImage={saveImage}
          toggle={() => setIsOpen(false)}
          aspect={4 / 5}
        />
        <InfoPopup
          size="lg"
          isOpen={previewOpen}
          toggle={togglePreview}
          title="Document Preview"
          previewFile={previewFile}
        />
        <PageLoader open={addAwardShortlistedDetailsScreen.loading} />
      </div>
    </div>
  )
}

export default NomineeAwardFormTwo
